import React from 'react'
import ImageSkeletonSvg from 'images/modules/Manage/i-image-skeleton.svg?raw'

export { default as ImageSkeletonUrl } from 'images/modules/Manage/i-image-skeleton.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ImageSkeletonSvg}} />
)
